<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive">
        <!-- 这里是会被缓存的视图组件，比如 page1,page2 -->
      </router-view>
    </keep-alive>
    <keep-alive>
      <router-view v-if="!$route.meta.keepAlive">
        <!-- 这里是不被缓存的视图组件，比如 page3 -->
      </router-view>
    </keep-alive>

  </div>
</template>

<script>
  import $ from 'jquery'
  import './components/js/Ext/layer/mobile/need/layer.css';
  import './components/js/Ext/layer/mobile/layer.js';
  export default {
    name: 'App',
    methods: {
      urlchangeing() {
        if (!localStorage.userId && location.hash != '#/') {
          this.$router.push({
            path: '/'
          })
        }
        setTimeout(this.urlchangeing, 500)
      }
    },

    mounted() {
      var _this = this
      setTimeout(function() {
        if (location.href.indexOf('#/index/shoplist') != -1) {
          $('html').css('overflow', 'visible');
        }
        if (location.href.indexOf('#/index/pornshoplist') != -1) {
          $('html').css('overflow', 'visible');
        }
        if (location.hash.indexOf('#/xieyi') != -1 || location.hash.indexOf('#/xieyi?') != -1) {
          return;
        }
        if (location.hash.indexOf('#/') != -1 || location.hash.indexOf('#/agreement?') != -1) {
          return;
        }
        if (location.hash.indexOf('#/') != -1 || location.hash.indexOf('#/gxhyXieyi?') != -1) {
          return;
        }
        _this.urlchangeing()
        if (localStorage.userId && location.hash == '#/' || localStorage.userId && !location.hash) { //登录状态存在就直接跳转
          _this.$router.push({
            path: '/index/'
          })
        } else if (!localStorage.userId && location.hash != '#/') {
          _this.$router.push({
            path: '/'
          })
        }
      }, 0)
    }
  }
</script>

<style>
  * {
    margin: 0;
    padding: 0;
    border: 0;
    outline: 0;
    text-decoration: none;
    list-style: none;
    color: none;
  }

  html {
    background-color: #e7e7e7;
    overflow: hidden;
  }

  .el-table {
    overflow: auto !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue